// Mock data for API responses when config.useMocks is true

export const mockWeatherData = {
  current: {
    temperature_2m: 45,
    relative_humidity_2m: 65,
    weather_code: 2,
    wind_speed_10m: 12
  },
  hourly: {
    time: [
      '2024-01-15T14:00',
      '2024-01-15T15:00',
      '2024-01-15T16:00',
      '2024-01-15T17:00',
      '2024-01-15T18:00',
      '2024-01-15T19:00',
      '2024-01-15T20:00',
      '2024-01-15T21:00',
      '2024-01-15T22:00',
      '2024-01-15T23:00',
    ],
    temperature_2m: [45, 44, 43, 42, 41, 40, 39, 38, 37, 36],
    weather_code: [2, 2, 3, 3, 51, 61, 61, 65, 71, 71]
  }
};

export const mockTrafficData = {
  sourceUpdated: new Date().toISOString(),
  results: [
    {
      location: {
        length: 1200,
        shape: {
          links: [
            {
              points: [
                { lat: 41.4995, lng: -81.6950 },
                { lat: 41.5015, lng: -81.6920 }
              ],
              length: 1200,
              functionalClass: 2
            }
          ]
        }
      },
      incidentDetails: {
        id: 'mock-accident-1',
        criticality: 'critical',
        type: 'accident',
        description: { value: 'I-90 E at Exit 170 (E 9th St)' },
        summary: { value: 'Multi-vehicle accident blocking right lane' }
      }
    },
    {
      location: {
        length: 800,
        shape: {
          links: [
            {
              points: [
                { lat: 41.4850, lng: -81.7100 },
                { lat: 41.4870, lng: -81.7080 }
              ],
              length: 800,
              functionalClass: 3
            }
          ]
        }
      },
      incidentDetails: {
        id: 'mock-construction-1',
        criticality: 'minor',
        type: 'construction',
        description: { value: 'Superior Ave between E 6th St and E 9th St' },
        summary: { value: 'Lane closure for utility work' }
      }
    },
    {
      location: {
        length: 2000,
        shape: {
          links: [
            {
              points: [
                { lat: 41.5100, lng: -81.6800 },
                { lat: 41.5120, lng: -81.6750 }
              ],
              length: 2000,
              functionalClass: 1
            }
          ]
        }
      },
      incidentDetails: {
        id: 'mock-delay-1',
        criticality: 'major',
        type: 'congestion',
        description: { value: 'I-90 W from E 55th St to Dead Man\'s Curve' },
        summary: { value: 'Heavy traffic, expect delays' }
      }
    },
    {
      location: {
        length: 500,
        shape: {
          links: [
            {
              points: [
                { lat: 41.4800, lng: -81.6700 },
                { lat: 41.4820, lng: -81.6680 }
              ],
              length: 500,
              functionalClass: 4
            }
          ]
        }
      },
      incidentDetails: {
        id: 'mock-closure-1',
        criticality: 'critical',
        type: 'roadClosure',
        description: { value: 'Carnegie Ave at E 14th St' },
        summary: { value: 'Road closed due to water main break' }
      }
    },
    {
      location: {
        length: 1500,
        shape: {
          links: [
            {
              points: [
                { lat: 41.4650, lng: -81.8200 },
                { lat: 41.4670, lng: -81.8150 }
              ],
              length: 1500,
              functionalClass: 2
            }
          ]
        }
      },
      incidentDetails: {
        id: 'mock-disabled-1',
        criticality: 'minor',
        type: 'disabledVehicle',
        description: { value: 'I-71 S near Bagley Rd' },
        summary: { value: 'Disabled vehicle on shoulder' }
      }
    },
    {
      location: {
        length: 3000,
        shape: {
          links: [
            {
              points: [
                { lat: 41.5200, lng: -81.6500 },
                { lat: 41.5250, lng: -81.6400 }
              ],
              length: 3000,
              functionalClass: 1
            }
          ]
        }
      },
      incidentDetails: {
        id: 'mock-construction-2',
        criticality: 'major',
        type: 'construction',
        description: { value: 'I-90 E between Martin Luther King Jr Dr and E 55th St' },
        summary: { value: 'Two lanes closed for bridge repairs' }
      }
    }
  ]
};

// Generate realistic train arrival times based on current time
const generateTrainTimes = (baseMinutes: number[]) => {
  const now = Date.now();
  return baseMinutes.map(min => now + (min * 60 * 1000));
};

export const mockTrainStopData = (stopId: string) => {
  const stopNames: { [key: string]: string } = {
    '28916': 'Tower City - Lower Level',
    '29008': 'Tower City - Center Platform'
  };

  const redLineTimes = generateTrainTimes([3, 18, 33]);
  const greenLineTimes = generateTrainTimes([7, 22, 37]);
  const blueLineTimes = generateTrainTimes([5, 20, 35]);
  const waterfrontTimes = generateTrainTimes([12, 27, 42]);

  const arrivals = [
    // Red Line
    {
      id: '66:1',
      routeId: '66',
      headsign: 'Airport',
      destination: 'Cleveland Hopkins Airport',
      subRoute: 'Red Line',
      direction: 'Outbound',
      arrive: redLineTimes[0],
      arriveScheduled: redLineTimes[0] - 60000,
      realtime: true
    },
    {
      id: '66:1',
      routeId: '66',
      headsign: 'Airport',
      destination: 'Cleveland Hopkins Airport',
      subRoute: 'Red Line',
      direction: 'Outbound',
      arrive: redLineTimes[1],
      arriveScheduled: redLineTimes[1],
      realtime: true
    },
    {
      id: '66:1',
      routeId: '66',
      headsign: 'Airport',
      destination: 'Cleveland Hopkins Airport',
      subRoute: 'Red Line',
      direction: 'Outbound',
      arrive: redLineTimes[2],
      arriveScheduled: redLineTimes[2] + 120000,
      realtime: false
    },
    // Green Line
    {
      id: '68:2',
      routeId: '68',
      headsign: 'Windermere',
      destination: 'Windermere',
      subRoute: 'Green Line',
      direction: 'Eastbound',
      arrive: greenLineTimes[0],
      arriveScheduled: greenLineTimes[0],
      realtime: true
    },
    {
      id: '68:2',
      routeId: '68',
      headsign: 'Windermere',
      destination: 'Windermere',
      subRoute: 'Green Line',
      direction: 'Eastbound',
      arrive: greenLineTimes[1],
      arriveScheduled: greenLineTimes[1] - 30000,
      realtime: true
    },
    {
      id: '68:2',
      routeId: '68',
      headsign: 'Windermere',
      destination: 'Windermere',
      subRoute: 'Green Line',
      direction: 'Eastbound',
      arrive: greenLineTimes[2],
      arriveScheduled: greenLineTimes[2],
      realtime: false
    },
    // Blue Line
    {
      id: '67:4',
      routeId: '67',
      headsign: 'Van Aken',
      destination: 'Van Aken',
      subRoute: 'Blue Line',
      direction: 'Eastbound',
      arrive: blueLineTimes[0],
      arriveScheduled: blueLineTimes[0] + 90000,
      realtime: true
    },
    {
      id: '67:4',
      routeId: '67',
      headsign: 'Van Aken',
      destination: 'Van Aken',
      subRoute: 'Blue Line',
      direction: 'Eastbound',
      arrive: blueLineTimes[1],
      arriveScheduled: blueLineTimes[1],
      realtime: true
    },
    {
      id: '67:4',
      routeId: '67',
      headsign: 'Van Aken',
      destination: 'Van Aken',
      subRoute: 'Blue Line',
      direction: 'Eastbound',
      arrive: blueLineTimes[2],
      arriveScheduled: blueLineTimes[2],
      realtime: false
    },
    // Waterfront Line
    {
      id: '69:1',
      routeId: '69',
      headsign: 'Waterfront',
      destination: 'North Coast Harbor',
      subRoute: 'Waterfront',
      direction: 'Northbound',
      arrive: waterfrontTimes[0],
      arriveScheduled: waterfrontTimes[0],
      realtime: true
    },
    {
      id: '69:1',
      routeId: '69',
      headsign: 'Waterfront',
      destination: 'North Coast Harbor',
      subRoute: 'Waterfront',
      direction: 'Northbound',
      arrive: waterfrontTimes[1],
      arriveScheduled: waterfrontTimes[1] - 60000,
      realtime: true
    },
    {
      id: '69:1',
      routeId: '69',
      headsign: 'Waterfront',
      destination: 'North Coast Harbor',
      subRoute: 'Waterfront',
      direction: 'Northbound',
      arrive: waterfrontTimes[2],
      arriveScheduled: waterfrontTimes[2],
      realtime: false
    }
  ];

  return {
    id: stopId,
    publicCode: stopId,
    name: stopNames[stopId] || 'Tower City Station',
    coordinates: [-81.6882, 41.4966] as [number, number],
    routes: ['66', '67', '68', '69'],
    arrivals: arrivals.filter(() => Math.random() > 0.3) // Randomly show some arrivals
  };
};

// Generate realistic bus arrival times
const generateBusTimes = (count: number, startMin: number = 2) => {
  const now = Date.now();
  return Array.from({ length: count }, (_, i) => now + ((startMin + i * 8) * 60 * 1000));
};

export const mockBusStopData = (stopId: string) => {
  const stopNames: { [key: string]: string } = {
    '06461': 'Euclid Ave at E 4th St',
    '06460': 'Euclid Ave at E 9th St',
    '00158': 'Superior Ave at Public Square',
    '08873': 'Ontario St at Prospect Ave',
    '00014': 'Prospect Ave at E 9th St'
  };

  const routes = [
    { id: '39:0', routeId: '39', route: '39', dest: 'Warrensville Heights', headsign: 'Warrensville' },
    { id: '45:1', routeId: '45', route: '45', dest: 'West Park', headsign: 'West Park' },
    { id: '26:0', routeId: '26', route: '26', dest: 'Richmond Heights', headsign: 'Richmond' },
    { id: '38:2', routeId: '38', route: '38', dest: 'Lakeview Rd', headsign: 'Lakeview' },
    { id: '81:0', routeId: '81', route: '81', dest: 'Shaker Square', headsign: 'Shaker' }
  ];

  const arrivals = routes.flatMap((route, index) => {
    const times = generateBusTimes(2, 2 + index * 3);
    return times.map((time, i) => ({
      id: route.id,
      routeId: route.routeId,
      headsign: route.headsign,
      destination: route.dest,
      subRoute: route.route,
      direction: 'Outbound',
      arrive: time,
      depart: time + 30000,
      arriveScheduled: time + (i === 0 ? -60000 : 0),
      departScheduled: time + 30000,
      realtime: true
    }));
  });

  return {
    id: stopId,
    publicCode: stopId,
    name: stopNames[stopId] || 'Bus Stop',
    coordinates: [-81.6882 + Math.random() * 0.01, 41.4966 + Math.random() * 0.01] as [number, number],
    routes: routes.map(r => r.routeId),
    arrivals: arrivals.slice(0, 9)
  };
};

export const mockPatternData = (patternId: string) => {
  // Generate mock coordinates for bus routes
  const baseCoords: [number, number] = [-81.6882, 41.4966];
  const coordinates: [number, number][] = Array.from({ length: 20 }, (_, i) => [
    baseCoords[0] + (Math.random() - 0.5) * 0.05,
    baseCoords[1] + (Math.random() - 0.5) * 0.05
  ]);

  const patterns: { [key: string]: any } = {
    '39:0': { headsign: 'Warrensville Heights', direction: 'Outbound' },
    '45:1': { headsign: 'West Park', direction: 'Outbound' },
    '26:0': { headsign: 'Richmond Heights', direction: 'Outbound' },
    '38:2': { headsign: 'Lakeview Rd', direction: 'Outbound' },
    '81:0': { headsign: 'Shaker Square', direction: 'Outbound' }
  };

  const pattern = patterns[patternId] || { headsign: 'Unknown', direction: 'Outbound' };

  return {
    id: patternId,
    headsign: pattern.headsign,
    direction: pattern.direction,
    coordinates
  };
};
